import script from "./H2rDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./H2rDashboard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__